import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CheckIcon from '@mui/icons-material/Check';

const HowItWorks = () => {
    const navigate = useNavigate();
    const steps = [
        {
            titulo: "Escolha seu plano.",
            desc: "Escolha o plano que melhor se adapta a você!",
            img: "/assets/howItWorks01.jpg"
        },
        {
            titulo: "Preencha os dados.",
            desc: "Só levará alguns minutos para completar o cadastro.",
            img: "/assets/howItWorks02.jpg"
        },
        {
            titulo: "Selecione o pagamento.",
            desc: "Finalize a contratação e comece a aproveitar nossos serviços.",
            img: "/assets/howItWorks03.jpg"
        },
    ];

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: i => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.2, duration: 0.5 }
        }),
    };

    return (
        <Box
            component="section"
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "#fff",
                py: { xs: 8, md: 12 },
            }}
        >
            <Box sx={{ width: "90%", maxWidth: "1280px" }}>
                {/* Cabeçalho */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.6 }}
                >
                    <Box sx={{ textAlign: "center", mb: { xs: 5, md: 7 } }}>
                        <Box
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1.75,
                                py: 0.75,
                                mb: 2.5,
                                borderRadius: "999px",
                                backgroundColor: "rgba(255, 200, 69, 0.25)",
                                color: "#0b243d",
                                fontSize: "0.8rem",
                                fontWeight: 700,
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                            }}
                        >
                            <Box sx={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#ffc845" }} />
                            Como funciona
                        </Box>
                        <h2 style={{ margin: "0 0 12px", fontSize: "clamp(1.8rem, 3.4vw, 2.6rem)", fontWeight: 800, lineHeight: 1.2, letterSpacing: "-0.5px", color: "#0b243d" }}>
                            Contrate em <span style={{ color: "#c8961e" }}>três passos</span>
                        </h2>
                        <Box component="p" sx={{ m: "0 auto", maxWidth: "560px", fontSize: { xs: "1rem", md: "1.05rem" }, lineHeight: 1.7, color: "#4b5563" }}>
                            Simples, rápido e 100% online. Em poucos minutos sua contabilidade já está em boas mãos.
                        </Box>
                    </Box>
                </motion.div>

                {/* Passos */}
                <Box
                    sx={{
                        position: "relative",
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
                        gap: { xs: 4, md: 4 },
                    }}
                >
                    {/* Linha que conecta os passos (desktop) */}
                    <Box
                        sx={{
                            display: { xs: "none", md: "block" },
                            position: "absolute",
                            top: { md: 200 },
                            left: "16.66%",
                            right: "16.66%",
                            borderTop: "2px dashed rgba(200, 150, 30, 0.45)",
                            zIndex: 0,
                        }}
                    />

                    {steps.map((item, index) => (
                        <motion.div
                            key={index}
                            custom={index}
                            variants={cardVariants}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                            style={{ position: "relative", zIndex: 1 }}
                        >
                            <Box sx={{ textAlign: "center", maxWidth: { xs: "420px", md: "none" }, mx: "auto" }}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: { xs: 200, md: 200 },
                                        borderRadius: "20px",
                                        backgroundColor: "#e5e7eb",
                                        backgroundImage: `url(${item.img})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        boxShadow: "0 16px 40px rgba(11, 36, 61, 0.15)",
                                    }}
                                />

                                {/* Número do passo */}
                                <Box
                                    sx={{
                                        width: 52,
                                        height: 52,
                                        mx: "auto",
                                        mt: "-26px",
                                        position: "relative",
                                        borderRadius: "50%",
                                        backgroundColor: "#0b243d",
                                        color: "#ffc845",
                                        border: "4px solid #fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "1.1rem",
                                        fontWeight: 800,
                                        boxShadow: "0 6px 16px rgba(11, 36, 61, 0.25)",
                                    }}
                                >
                                    {String(index + 1).padStart(2, "0")}
                                </Box>

                                <Box sx={{ mt: 2, fontSize: "1.2rem", fontWeight: 700, color: "#0b243d" }}>{item.titulo}</Box>
                                <Box sx={{ mt: 1, fontSize: "0.95rem", lineHeight: 1.6, color: "#4b5563", maxWidth: "300px", mx: "auto" }}>{item.desc}</Box>
                            </Box>
                        </motion.div>
                    ))}
                </Box>

                {/* Chamada para ação */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3, duration: 0.5 }}
                >
                    <Box
                        sx={{
                            mt: { xs: 6, md: 8 },
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: "center",
                            justifyContent: "center",
                            gap: { xs: 1.5, sm: 3 },
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={() => {
                                navigate("../planos")
                            }}
                            sx={{
                                width: { xs: "100%", sm: "auto" },
                                px: 4,
                                py: 1.75,
                                fontSize: "1rem",
                                fontWeight: 700,
                                textTransform: "none",
                                backgroundColor: "#ffc845",
                                color: "#0b243d",
                                borderRadius: "10px",
                                boxShadow: "0 8px 24px rgba(255, 200, 69, 0.35)",
                                transition: "all 0.2s ease",
                                '&:hover': {
                                    backgroundColor: "#e9b53d",
                                    transform: "translateY(-2px)",
                                    boxShadow: "0 10px 28px rgba(255, 200, 69, 0.45)",
                                },
                            }}
                        >
                            Escolha um plano
                        </Button>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#6b7280", fontSize: "0.9rem" }}>
                            <CheckIcon sx={{ fontSize: 18, color: "#c8961e" }} />
                            Sem multa e sem fidelidade
                        </Box>
                    </Box>
                </motion.div>
            </Box>
        </Box>
    );
};

export default HowItWorks;
